import React, { useState } from 'react'
import axios from 'axios'
import { baseURL } from '../config'
import { useSubscription } from '../context/SubscriptionContext'

// Simple flag to track if user dismissed invitation this session
export let invitationDismissed = false

export function setInvitationDismissed(value) {
	invitationDismissed = value
}

function TeamInvitationModal() {
	const { subscriptionData } = useSubscription()
	const [processing, setProcessing] = useState(false)
	const [dismissed, setDismissed] = useState(false)

	const pendingInvitations = subscriptionData?.pendingInvitations || []

	const handleRespond = async (invitationId, action) => {
		setProcessing(true)
		try {
			await axios.post(`${baseURL}/api/team/invitation/${invitationId}/respond`, {
				action,
			})
			window.location.reload()
		} catch (error) {
			console.error('Error responding to invitation:', error)
			alert(error.response?.data?.message || 'Failed to respond to invitation')
		} finally {
			setProcessing(false)
		}
	}

	const handleClose = () => {
		setInvitationDismissed(true)
		setDismissed(true)
	}

	if (!pendingInvitations || pendingInvitations.length === 0 || dismissed) {
		return null
	}

	return (
		<div className="relative z-50">
			<div className="fixed inset-0 bg-gray-900/50 transition-opacity" />

			<div className="fixed inset-0 z-10 flex items-start justify-center pt-20 p-4">
				<div className="w-full max-w-2xl">
					<div className="relative transform overflow-hidden rounded-lg bg-gray-800 px-6 pt-10 pb-6 text-left shadow-xl outline outline-1 -outline-offset-1 outline-white/10 transition-all sm:px-8 sm:pt-12 sm:pb-8">
						<button
							type="button"
							onClick={handleClose}
							className="absolute top-4 right-4 text-gray-400 hover:text-gray-300 transition-colors"
						>
							<svg
								className="h-6 w-6"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</button>

						<h3 className="text-base font-semibold text-white mb-4">
							Team Invitation
						</h3>

						{pendingInvitations.map(invitation => (
							<div key={invitation._id} className="mb-6">
								<p className="text-sm text-gray-300 mb-6">
									You've been invited to join{' '}
									<span className="font-semibold text-white">
										{invitation.teamName}
									</span>
								</p>

								<div className="flex gap-3 justify-end">
									<button
										onClick={() => handleRespond(invitation._id, 'decline')}
										disabled={processing}
										className="rounded-md bg-gray-700 px-6 py-2 text-sm font-semibold text-white hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
									>
										Decline
									</button>
									<button
										onClick={() => handleRespond(invitation._id, 'accept')}
										disabled={processing}
										className="rounded-md bg-blue-600 px-6 py-2 text-sm font-semibold text-white hover:bg-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
									>
										{processing ? 'Processing...' : 'Accept'}
									</button>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	)
}

export default TeamInvitationModal
